import React from 'react';
import { Icon, Tooltip } from 'antd';
import styles from './Comment.module.scss';

const MessageOption = ({
  onEditBtnClick,
  onDeleteBtnClick,
  onChangeAvailability,
  availableForClient,
}) => {
  return (
    <div className={styles.messageOptionIcons}>
      {typeof onEditBtnClick === 'function' && (
        <div className={styles.messageOptionIcon} onClick={onEditBtnClick}>
          <Icon type="edit" />
        </div>
      )}
      {typeof onDeleteBtnClick === 'function' && (
        <div className={styles.messageOptionIcon} onClick={onDeleteBtnClick}>
          <Icon type="delete" theme="filled" />
        </div>
      )}

      {typeof onChangeAvailability === 'function' && (
        <Tooltip
          title={
            availableForClient
              ? 'Не показывать собственнику'
              : 'Показывать собственнику'
          }
        >
          <div
            className={styles.messageOptionIcon}
            onClick={onChangeAvailability}
          >
            <Icon
              type={availableForClient ? 'eye-invisible' : 'eye'}
              theme="filled"
            />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default MessageOption;
